import { lazy, Suspense, useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  // Link,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { PortfolioProvider } from "./context/PortfolioContext";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Projects = lazy(() => import("./pages/Projects"));
const ProjectDetail = lazy(() => import("./pages/Projects/ProjectDetail"));
const Contact = lazy(() => import("./pages/Contact"));
const Gallery = lazy(() => import("./pages/gallery/gallery"));
const Admin = lazy(() => import("./pages/Admin"));
const PageNotFound = lazy(() => import("./pages/404/PageNotFound"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="page-loader" role="status" aria-label="Loading…" />
    </div>
  );
}

function AppShell() {
  const [darkMode, setDarkMode] = useState(true);
  // const { pathname } = useLocation();
  // const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light",
    );
    document.documentElement.classList.toggle("light-mode", !darkMode);
  }, [darkMode]);

  const toggleProps = {
    darkMode,
    handleToggle: () => setDarkMode((d) => !d),
  };

  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home {...toggleProps} />} />
          <Route path="/about" element={<About {...toggleProps} />} />
          <Route path="/projects" element={<Projects {...toggleProps} />} />
          <Route
            path="/projects/:id"
            element={<ProjectDetail {...toggleProps} />}
          />
          <Route path="/contact" element={<Contact {...toggleProps} />} />
          <Route path="/gallery" element={<Gallery {...toggleProps} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>

      {/* Subtle admin shortcut — only visible on public pages */}
      {/* {!isAdmin && (
        <Link
          to="/admin"
          className="admin-shortcut"
          aria-label="Go to admin panel"
          tabIndex={-1}
        >
          ⚙ admin
        </Link>
      )} */}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <PortfolioProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppShell />
        </BrowserRouter>
      </PortfolioProvider>
    </HelmetProvider>
  );
}

export default App;
